import * as React from 'react';
import EmptyProgressPng from './empty-progress-card.png';
import './emptyProgressCard.module.scss';
import { V3Routes } from '../../routes';
import { LinkButton } from '@sheinc/shelikes-design-system';

export const EmptyProgressCard = () => (
  <div styleName="empty-progress-card">
    <img src={EmptyProgressPng} styleName="icon" />
    <div styleName="body">
      <div>
        <div styleName="header">レッスンを始めよう</div>
        <div styleName="text">まだ学習中のレッスンはありません。コース一覧からレッスンをはじめましょう。</div>
      </div>
      <LinkButton variant="secondary" size="small" to={V3Routes.courses()}>
        コース一覧へ
      </LinkButton>
    </div>
  </div>
);
